import { ContainerModule } from 'inversify';
import PaymentMethodService from '../features/paymentMethods/data/service/PaymentMethodsService';
import PaymentMethodRepository from '../features/paymentMethods/data/PaymentMethodsRepository';
import { PaymentMethodServiceInterface } from '../features/paymentMethods/data/service/PaymentMethodsService.types';
import { PaymentMethodRepositoryInterface } from '../features/paymentMethods/domain/PaymentMethodsRepositoryInterface.types';
import { CreditCardsServiceInterface } from 'src/features/creditCards/data/service/CreditCardsService.types';
import CreditCardsService from 'src/features/creditCards/data/service/CreditCardsService';
import { CreditCardsRepositoryInterface } from 'src/features/creditCards/domain/CreditCardsRepositoryInterface.types';
import CreditCardsRepository from 'src/features/creditCards/data/CreditCardsRepository';
import DeleteCardUseCase from 'src/features/creditCards/domain/useCases/DeleteCardUseCase';
import { CompanyDataSourceInterface } from 'src/features/companies/data/CompanyDataSource.types';
import CompanyDataSource from 'src/features/companies/data/CompanyDataSource';
import { CompanyCreditRepositoryInterface } from 'src/features/efektivaCredit/domain/repositories/CompanyCreditRepository.types';
import CompanyCreditRepository from 'src/features/efektivaCredit/domain/repositories/CompanyCreditRepository';
import {
  SaveMercadoPagoCardUseCase,
  SaveOpenPayCardUseCase,
} from 'src/features/creditCards/domain/useCases';

export const paymentMethodsBindings = new ContainerModule((bind) => {
  // Services
  bind<PaymentMethodServiceInterface>(PaymentMethodService).to(
    PaymentMethodService
  );
  bind<CreditCardsServiceInterface>(CreditCardsService).to(CreditCardsService);
  bind<CompanyDataSourceInterface>(CompanyDataSource).to(CompanyDataSource);

  // Repositories
  bind<PaymentMethodRepositoryInterface>(PaymentMethodRepository).to(
    PaymentMethodRepository
  );
  bind<CreditCardsRepositoryInterface>(CreditCardsRepository).to(
    CreditCardsRepository
  );
  bind<CompanyCreditRepositoryInterface>(CompanyCreditRepository).to(
    CompanyCreditRepository
  );

  // Use cases
  bind<DeleteCardUseCase>(DeleteCardUseCase).to(DeleteCardUseCase);
  bind<SaveOpenPayCardUseCase>(SaveOpenPayCardUseCase).to(
    SaveOpenPayCardUseCase
  );
  bind<SaveMercadoPagoCardUseCase>(SaveMercadoPagoCardUseCase).to(
    SaveMercadoPagoCardUseCase
  );
});
